import TagManager from 'react-gtm-module';
import { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';

TagManager.initialize({
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID as string,
  auth: process.env.REACT_APP_GTM_AUTH,
  preview: process.env.REACT_APP_GTM_ENV,
});

type Organization = {
  address: string;
  category: string;
  name: string;
  id: string;
}

type Me = {
  id: string;
  email: string;
  name: string;
  accountRole: string;
}

type AdminRelationships = {
  loading: boolean;
  data: {
    me: Me;
    org: Organization;
  };
}

type TrackingPixelProps = {
  orgAdmin: AdminRelationships;
};

function TrackingPixel({ orgAdmin }: TrackingPixelProps ): null {
  const trackingData = useMemo(() => {
    return {
      userId: orgAdmin?.data?.me?.id,
      name: orgAdmin?.data?.me?.name,
      role: orgAdmin?.data?.me?.accountRole,
      email: orgAdmin?.data?.me?.email,
    };
  }, [orgAdmin]);

  useEffect(() => {
    if(trackingData) {

      TagManager.dataLayer({
        dataLayer: {
          event: 'ct.identify',
          ...trackingData,
        },
      });
    }
  }, [trackingData]);

  return null;
}

const mapStateToProps = (state: any) => ({
  orgAdmin: state.admin.adminRelationships,
});

export default connect(
  mapStateToProps,
)(TrackingPixel);
